export default "__VITE_ASSET__RuFa58SW__"